import {
  ClassificationsBrowserAutocompleteQuery,
  ClassificationsBrowserSearchSettings,
  ClassificationsBrowserTreeViewEnum,
  ClassificationsBrowserAppSettings,
  ClientInfo,
  ClassificationsBrowserFilters,
  ApplicationUseSettings,
  CountryMarketAvailabilitySettings,
  LifeCyclePhaseModeEnum,
  PagerSettings,
  ClassificationsBrowserAutocompleteResult,
  ClassificationsBrowserChildrenQuery,
  ClassificationsBrowserChildrenSearchSettings,
  ClassificationsBrowserTreeTypeEnum,
  ClassificationsBrowserChildrenResult,
  ClassificationsBrowserNode,
  ProductGroup,
  ProductGroupValidationStatusEnum,
  ClassificationsBrowserNodeReference,
  ClassificationsBrowserPathQuery,
  ClassificationsBrowserPathSearchSettings,
  ClassificationsBrowserPathNode,
  ClassificationsBrowserSearchQuery,
  ClassificationsBrowserSearchResult,
  ClassificationsBrowserValidateQuery,
  ClassificationsBrowserValidateSearchSettings,
  ClassificationsBrowserValidateNode,
  ClassificationsBrowserValidateResult,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class ClassificationsBrowserService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Provides autocomplete suggestions for classification node names based on a partial search text.
   */
  static autocomplete(
    params: {
      /** requestBody */
      body?: ClassificationsBrowserAutocompleteQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsBrowserAutocompleteResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Browser/Autocomplete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Retrieves the direct child nodes of a specified classification node.
   */
  static children(
    params: {
      /** requestBody */
      body?: ClassificationsBrowserChildrenQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsBrowserChildrenResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Browser/Children';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Retrieves the full path (breadcrumb) from root to the specified classification node.
   */
  static path(
    params: {
      /** requestBody */
      body?: ClassificationsBrowserPathQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsBrowserNode> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Browser/Path';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Searches for classification nodes matching the specified criteria and returns matching nodes with their hierarchy.
   */
  static search(
    params: {
      /** requestBody */
      body?: ClassificationsBrowserSearchQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsBrowserSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Browser/Search';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Validates a list of classification CIDs and separates them into valid and invalid nodes.
   */
  static validate(
    params: {
      /** requestBody */
      body?: ClassificationsBrowserValidateQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationsBrowserValidateResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Classifications/Browser/Validate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
